import { createContext, useState } from "react";

const DataManager = createContext();

const DataManagerProvider = ({ children }) => {
  const [citySelected, setCitySelected] = useState(null);

  return (
    <DataManager.Provider
      value={{
        citySelected,
        setCitySelected,
      }}
    >
      {children}
    </DataManager.Provider>
  );
};

export { DataManagerProvider };
export default DataManager;
